'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getActiveUsersByBoards = undefined;

var _reselect = require('reselect');

var _lodash = require('lodash');

var _popupOpenSelector = require('../../../../components/popupPanel/popupOpenSelector');

var _popupOpenSelector2 = _interopRequireDefault(_popupOpenSelector);

var _usersSelector = require('../../../../user/usersSelector');

var _milanoteReselect = require('../../../../utils/milanoteReselect/milanoteReselect');

var _userUtil = require('../../../../user/userUtil');

var _resourceUtil = require('../../../../utils/services/http/resources/resourceUtil');

var _permissionsService = require('../../../../utils/permissions/permissionsService');

var _liveEditingUtilConstants = require('./liveEditingUtilConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getActiveUsersByBoards = exports.getActiveUsersByBoards = (0, _reselect.createSelector)(function (state) {
    return state.get('users');
}, function (state) {
    return state.get('elements');
}, function (state) {
    return state.getIn(['app', 'currentUser', '_id']);
}, function (users, elements, currentUserId) {
    return (0, _lodash.values)(users.reduce(function (boardIdMap, user) {
        if (user.get('_id') === currentUserId || !(0, _userUtil.isOnline)(user)) return boardIdMap;
        var remoteUserId = user.get('_id');
        var usersCurrentBoardId = user.get('currentBoardId');

        if ((0, _permissionsService.canSaveBoard)(elements, usersCurrentBoardId, currentUserId) && (0, _permissionsService.canSaveBoard)(elements, usersCurrentBoardId, remoteUserId)) {
            boardIdMap[usersCurrentBoardId] = boardIdMap[usersCurrentBoardId] || { boardId: usersCurrentBoardId, users: [] };
            boardIdMap[usersCurrentBoardId].users.push(remoteUserId);
        }

        return boardIdMap;
    }, {}));
});

// Constants


// Utils


// Selectors
// Lib


var getActiveUsers = (0, _reselect.createSelector)(function (state) {
    return state.get('users');
}, function (state) {
    return state.get('elements');
}, function (state) {
    return state.getIn(['app', 'currentUser', '_id']);
}, function (users, elements, currentUserId) {
    return users.filter(function (user) {
        var remoteUserId = user.get('_id');
        var userCurrentBoardId = user.get('currentBoardId');
        return user.get('_id') !== currentUserId && (0, _userUtil.isOnline)(user) && (0, _permissionsService.canSaveBoard)(elements, userCurrentBoardId, currentUserId) && (0, _permissionsService.canSaveBoard)(elements, userCurrentBoardId, remoteUserId);
    });
});

var getActiveUserIds = (0, _milanoteReselect.createShallowSelector)(getActiveUsers, function (activeUsers) {
    return activeUsers.keySeq().toArray();
});

var getActiveUserResources = (0, _usersSelector.makeFilteredUsersResourcesSelector)(getActiveUserIds);

var getErrorActiveUserIds = (0, _milanoteReselect.createShallowSelector)(getActiveUserResources, function (activeUserResourcesState) {
    return activeUserResourcesState.filter(_resourceUtil.isError).keySeq().toArray();
});

var getFetchingActiveUserIds = (0, _milanoteReselect.createShallowSelector)(getActiveUserResources, function (activeUserResourcesState) {
    return activeUserResourcesState.filter(_resourceUtil.isFetching).keySeq().toArray();
});

var getActiveUserCount = (0, _reselect.createSelector)(getActiveUsers, function (activeUsers) {
    return activeUsers.size;
});

exports.default = (0, _reselect.createSelector)((0, _popupOpenSelector2.default)(_liveEditingUtilConstants.LIVE_EDITING_POPUP_ID), getActiveUserCount, getActiveUsersByBoards, getErrorActiveUserIds, getFetchingActiveUserIds, function (popupOpen, activeUserCount, activeUsersByBoards, errorActiveUserIds, fetchingActiveUserIds) {
    return {
        popupOpen: popupOpen,
        activeUserCount: activeUserCount,
        activeUsersByBoards: activeUsersByBoards,
        errorActiveUserIds: errorActiveUserIds,
        fetchingActiveUserIds: fetchingActiveUserIds
    };
});


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/liveEditing/liveEditingUtilSelector.js
// module id = 780
// module chunks = 0